import { useQueryMultipleChoices } from '../api/useQueryMultipleChoices'

export const useMultipleChoices = () => {
  const query = useQueryMultipleChoices()

  return {
    multipleChoiceGroups: query.data ?? [],
    isError: query.isError,
    error: query.error,
    isLoading: query.isLoading,
  }
}
